import { Chart as ChartJS, TooltipModel } from "chart.js";

type PositionTooltipArgs = {
  chart: ChartJS;
  tooltip: TooltipModel<"line">;
  tooltipEl: HTMLDivElement;
  lineEl: HTMLDivElement;
};

const positionTooltip = ({
  chart,
  tooltip,
  tooltipEl,
  lineEl,
}: PositionTooltipArgs) => {
  if (tooltip.opacity === 0) {
    tooltipEl.style.opacity = "0";
    lineEl.style.opacity = "0";
    return;
  }

  const { offsetLeft: positionX, offsetTop: positionY } = chart.canvas;
  const yBox = chart.boxes.find((box) => "id" in box && box.id === "y");

  lineEl.style.opacity = "1";
  lineEl.style.position = "absolute";
  lineEl.style.left = `${tooltip.dataPoints.at(0)!.element.x}px`;
  lineEl.style.top = `${yBox?.top}px`;
  lineEl.style.height = `${yBox?.height}px`;
  lineEl.style.width = "1px";
  lineEl.style.backgroundColor = "#5DB4A1";

  tooltipEl.style.padding = "8px";
  tooltipEl.style.opacity = "1";
  tooltipEl.style.top = positionY + tooltip.caretY + "px";

  const tooltipWidth = tooltipEl.offsetWidth;
  const containerWidth =
    chart.canvas.parentElement?.clientWidth ?? chart.width;
  const caretX = positionX + tooltip.caretX;

  if (caretX + tooltipWidth > containerWidth) {
    tooltipEl.style.left = `${caretX - tooltipWidth}px`;
  } else {
    tooltipEl.style.left = `${caretX}px`;
  }
};

export { positionTooltip };
